<app-nav #navbar></app-nav>
<div class="main-content" #mainContent>
  <router-outlet />
</div>
<app-footer></app-footer>
<app-popup [visible]="showPopup" (closed)="onPopupClosed()"> </app-popup>
